import React from 'react';
import classNames from 'classnames';

import { TextRow } from '@thd-olt-component-react/loading-placeholder';

import styles from '../rental-fulfillment.module.scss';

export const LoadingFulfillment = () => {
  return (
    <div data-testid="loading" className={classNames(styles['rental-fulfillment__details-container'])}>
      {['60', '75', '50', '50'].map((col, index) => {
        return (
          <div key={`filter-fast-${index}`} style={{ display: 'flex', width: '100%' }}>
            <TextRow style={{ width: `${col}%` }} color="#E0E0E0" />
          </div>
        );
      })}
    </div>
  );
};
